import { render, staticRenderFns } from "./ContactsSection.vue?vue&type=template&id=bbabe3e8&scoped=true&"
import script from "./ContactsSection.vue?vue&type=script&lang=js&"
export * from "./ContactsSection.vue?vue&type=script&lang=js&"
import style0 from "./ContactsSection.vue?vue&type=style&index=0&id=bbabe3e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbabe3e8",
  null
  
)

component.options.__file = "ContactsSection.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VCardTitle,
  VContainer,
  VFlex,
  VLayout,
})
